import { useEffect, useState } from "react";
import { useGetVariantForFeatureQuery } from "redux/reduxAPI";
import {
  CAMPAIGN_THEME_FEATURE,
  CAMPAIGN_THEME_VARIANT_STORAGE_KEY,
  getCampaignThemeById,
  getServerThemeVariant,
} from "utils/campaignTheme";
import { loadState, removeState, saveState } from "utils/localStorage";

/**
 * The campaign theme the CAMPAIGN_THEME flag selects, or null. Until the flag
 * server answers (cold start, offline, server error) the last answer cached
 * in localStorage applies, so the splash intro can decide on mount.
 */
export const useCampaignTheme = () => {
  const [cachedVariant] = useState<string | undefined>(() =>
    loadState(CAMPAIGN_THEME_VARIANT_STORAGE_KEY)
  );
  const { data, error, isSuccess } = useGetVariantForFeatureQuery({
    feature_name: CAMPAIGN_THEME_FEATURE,
  });
  const serverVariant = getServerThemeVariant({ data, error, isSuccess });

  useEffect(() => {
    if (serverVariant === undefined) return;
    if (serverVariant === null) {
      removeState(CAMPAIGN_THEME_VARIANT_STORAGE_KEY);
    } else {
      saveState(CAMPAIGN_THEME_VARIANT_STORAGE_KEY, serverVariant);
    }
  }, [serverVariant]);

  return getCampaignThemeById(
    serverVariant === undefined ? cachedVariant : serverVariant
  );
};
